/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

 import React, {useState, useEffect} from 'react';
 import { Grid, FormControlLabel, Checkbox, Tooltip} from '@material-ui/core';
 import LowPriorityOutlinedIcon from '@material-ui/icons/LowPriorityOutlined';
 
 export default function Elevate(props)
 {
     const [Elevate, setElevate] = useState(false);
 
     /** Set disposition to value being passed through props */
     useEffect(() => {
         setElevate(props.value);
     },[props.value])
 
     // Handle hold checkbox change
     const handleElevate = () => {
         setElevate(!Elevate);
         props.onChange(!Elevate);
     }
 
     return(
         <div>
             <Grid container direction="row" alignItems="center">
                 <Grid item>
                     <FormControlLabel
                     control={
                         <Checkbox
                         checked={Elevate}
                         onChange={handleElevate}
                         name="Elevate"
                         color="primary"
                         />
                     }
                     label="Elevate"
                     />
                 </Grid>
                 <Grid item>
                     <Tooltip title="Give permission for elevate Property">
                         <LowPriorityOutlinedIcon color="primary" style= {{"transform": "rotate(180deg)"}} />
                     </Tooltip>
                 </Grid>
 
             </Grid>
             
         </div>
     );
 }
 
 